<template>
    <div>
        <Header title="购物车"/>
        <div class="scrollerView">
            <scroller
                :on-refresh="refresh1"
                :on-infinite="infinite1"
                :noDataText="dataSource1.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite1"
                class="scroller"
            >
                <div class="item" v-for="(item, index) in dataSource1" :key="index">
                    <div class="header flex rcb">
                        <div class="left-wrap title-wrap flex rcs">
                            <div v-if="!item.check" class="un-check" @click="onPressCheck(true, index)"></div>
                            <div v-else class="check" @click="onPressCheck(false, index)">
                                <img :src="Images.icon_check" alt="">
                            </div>
                            <p>{{item.company_name}}</p>
                        </div>
                        <div class="right-wrap detail-wrap">
                            <div class="freight-wrap">{{item.freight_tips}}</div>
                        </div>
                    </div>
                    <van-swipe-cell v-for="(_item, _index) in item.goods" :key="_index">
                        <div class="goods">
                            <div v-if="!_item.check" class="un-check" @click.stop="onPressCheck(true, index, _index)"></div>
                            <div v-else class="check" @click.stop="onPressCheck(false, index, _index)">
                                <img :src="Images.icon_check" alt="">
                            </div>
                            <div class="body">
                                <img :src="_item.image" alt="" @click.stop="onPressNav('goodsDetail', {id: _item.goods_id})">
                                <div>
                                    <p class="title" @click.stop="onPressNav('goodsDetail', {id: _item.goods_id})">{{_item.name}}</p>
                                    <p class="unit" @click.stop="onPressNav('goodsDetail', {id: _item.goods_id})">规格:{{_item.sku_field_name}}</p>
                                    <div>
                                        <p @click.stop="onPressNav('goodsDetail', {id: _item.goods_id})">￥{{_item.sku_price}}</p>
                                        <div>
                                            <img v-if="_item.qty > 1" :src="Images.icon_reduce" alt="" @click.stop="onPressReduce(index, _index)">
                                            <img v-else :src="Images.icon_reduce" alt="">
                                            <input type="text" v-model="_item.qty">
                                            <img :src="Images.icon_add" alt="" @click.stop="onPressAdd(index, _index)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template #right>
                            <van-button class="delete" square type="danger" text="删除" @click="onPressDelete(_item.id)"/>
                        </template>
                    </van-swipe-cell>
                </div>
                <van-empty description="暂无信息～" v-if="dataSource1.length < 1 && !loading" />
            </scroller>
        </div>
        <div class="footer">
            <div class="check" @click="onPressCheckAll()">
                <div v-if="!check1"></div>
                <img v-else :src="Images.icon_check" alt="">
                <p>全选</p>
            </div>
            <p class="flex rcs">
                <span class="title">合计：</span>
                <span class="value">￥{{parseFloat(price1).toFixed(2)}}</span>
            </p>
            <div class="btn" @click="onPressSubmit()">结算</div>
        </div>
        <FooterShop :idx="3" />
    </div>
</template>

<script>
import Header from '@/components/Header'
import FooterShop from '@/components/FooterShop'
import Lockr from 'lockr'
import { mapGetters } from "vuex";
import { unique } from "@/utils/tool";
export default {
    components: {
        'Header': Header,
        'FooterShop': FooterShop,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    setup() {
        const active = 0;
        return { active };
    },
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            scrollHeight: 0, // 滚动区域高度
            active: 0,
            page1: 0,
            page2: 0,
            limit: 10,
            price1: 0,
            price2: 0,
            check1: false,
            check2: false,
            dataSource1: [],
            dataSource2: [],
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.scrollHeight = this.wrapperHeight - 100
    },
    methods: {
        // -------------------------------------------------- request  --------------------------------------------------
        async requestData1() {
            let url = this.API.shop_cart_cart_list;
            let params = {
                
                page: this.page1,
                limit: this.limit,
                shop_id: 1, // 1商城一  2商城二
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSource1.slice();
            let dataList = result.data.cart_list;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page1 === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSource1 = dataSourcesTemp
                that.$refs.infinite1.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        async requestData2() {
            let url = this.API.shop_cart_cart_list;
            let params = {
                
                page: this.page2,
                limit: this.limit,
                shop_id: 2, // 1商城一  2商城二
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSource2.slice();
            let dataList = result.data.cart_list;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page2 === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.data;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSource2 = dataSourcesTemp
                that.$refs.infinite2.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- mothed  --------------------------------------------------
        // 刷新
        refresh1() {
            this.page1 = 1;
            this.requestData1();
            setTimeout(function () {
                this.$refs.infinite1.finishPullToRefresh();
            }.bind(this), 1000)
        },
        refresh2() {
            this.page2 = 1;
            this.requestData2();
            setTimeout(function () {
                this.$refs.infinite2.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite1() {
            this.page1++
            this.requestData1();
        },
        infinite2() {
            this.page2++
            this.requestData2();
        },
        // 校验全选
        checkChoice() {
            let {active, dataSource1, dataSource2} = this;
            let array = []
            active === 0 ? array = dataSource1.slice() : array = dataSource2.slice();
            let check = true
            array.forEach(item => {
                if (!item.check) check = false
            });
            active === 0 ? this.check1 = check : this.check2 = check
        },
        // 校验总价
        checkPrice() {
            let {active, dataSource1, dataSource2} = this;
            let array = []
            active === 0 ? array = dataSource1.slice() : array = dataSource2.slice()
            let price = 0
            array.forEach(item => {
                item.goods.forEach(_item => {
                    if (_item.check) price = Number(_item.price).toFixed(2) * Number(_item.qty) + price
                })
            });
            active === 0 ? this.price1 = price : this.price2 = price
        },
        // 提交购物车内的商品数量
        async changeCart(index, _index) {
            let array = this.active === 0 ? this.dataSource1 : this.dataSource2;
            let url = this.API.shop_update;
            let params = {
                
                // shop_id: this.active*1 + 1,
                // goods_id: array[index].goods[_index].goods_id,
                // sku_field: array[index].goods[_index].sku_field,
                qty: array[index].goods[_index].qty,
                cart_id: array[index].goods[_index].id,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                console.log('成功更新购物车', result)
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // -------------------------------------------------- onPress  --------------------------------------------------
        // 点击跳转
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
        // 点击全选
        onPressCheckAll() {
            let {active, check1, check2, dataSource1, dataSource2} = this;
            let array = [], check = false;
            if (active === 0) {
                array = dataSource1.slice();
                if (array.length === 0) {
                    return false
                }
                check = !check1
                this.check1 = !check1
            } else {
                array = dataSource2.slice();
                if (array.length === 0) {
                    return false
                }
                check = !check2
                this.check2 = !check2
            }
            if (check) {
                array.forEach(item => {
                    item.check = true
                    item.goods.forEach(_item => {
                        _item.check = true
                    })
                });
            } else {
                array.forEach(item => {
                    item.check = false
                    item.goods.forEach(_item => {
                        _item.check = false
                    })
                });
            }
            active === 0 ? this.dataSource1 = array : this.dataSource2 = array
            this.checkPrice();
        },
        // 点击选择
        onPressCheck(value, index, _index) {
            let {active, dataSource1, dataSource2} = this;
            let array = active === 0 ? dataSource1.slice() : dataSource2.slice();
            if (_index === undefined) {
                array[index].check = value
                array[index].goods.forEach(item => {
                    item.check = value
                })
            } else {
                let asd = true
                array[index].goods.forEach((e, i) => {
                    if (i === _index) e.check = value;
                    if (!e.check) asd = false
                })
                array[index].check = asd
            }
            active === 0 ? this.dataSource1 = array : this.dataSource2 = array;
            this.checkChoice();
            this.checkPrice();
        },
        // 点击减号
        onPressReduce(index, _index) {
            let {active, dataSource1, dataSource2} = this;
            active === 0 ? dataSource1[index].goods[_index].qty-- : dataSource2[index].goods[_index].qty--
            this.checkPrice();
            this.changeCart(index, _index);
        },
        // 点击加号
        onPressAdd(index, _index) {
            let {active, dataSource1, dataSource2} = this;
            active === 0 ? dataSource1[index].goods[_index].qty++ : dataSource2[index].goods[_index].qty++
            this.checkPrice();
            this.changeCart(index, _index);
        },
        // 点击顶部tab
        onClickTab () {
            let {active} = this;
        },
        // 点击删除
        async onPressDelete(id) {
            let url = this.API.shop_cart_del;
            let params = {
                
                cart_id_list: id,
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.active === 0 ? this.refresh1() : this.refresh2();
                this.Message({
                    title: result.msg,
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 点击结算
        async onPressSubmit() {
            let token = this.Lockr.get('token')
            if (!token) {
                return this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            }
            if(!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            let shop_id = this.active === 0 ? 1 : 2,
                goods = [],
                company = [],
                special = [],
                goods_list = [];
            let dataSources = shop_id === 1 ? this.dataSource1.slice() : this.dataSource2.slice();

            let checkStatus = true;
            dataSources.forEach(item => {
                console.log('item---->', item);
                let _goods = [];
                let _company = [];
                let _special = [];
                item.goods.forEach(_item => {
                    console.log('_item---->', _item);
                    if(_item.check) {
                        _goods.push(_item);
                        _company.push(_item.trade_company_id);
                        _special.push(_item.is_special);
                    }
                })

                console.log('_company, _special---->', _company, _special);

                if (_goods.length > 0) {
                    goods.push({
                        name: item.company_name,
                        list: _goods,
                    });
                    company = company.concat(_company);
                    special = special.concat(_special);
                    goods_list = goods_list.concat(_goods);
                }
            });

            console.log('goods, goods_list, company, special---->', goods, goods_list, company, special);
            if (goods.length < 1) {
                return this.ToastManager('请选择结算商品');
            }
            if (unique(company).length > 1) {
                return this.ToastManager('该订单存在多个仓库的商品，请单独下单');
            }
            if (unique(special).length > 1) {
                return this.ToastManager('该订单存在财库不包邮，请单独下单');
            }

            let url = this.API.shop_preview_check_order;
            let data = {
                goods_list,
            }
            let result = await this.$post(url, data);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                // 本地存储下单商品数据
                let goods_str = JSON.stringify(goods)
                this.Lockr.set('goods_str', goods_str)
                this.$router.push({path: '/orderConfirm', query: {shop_id}})
            } else {
                this.ToastManager(result.msg);
            }
        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
    height: calc(100vh - 100px);
}

.scroller {
    background: #F8F8F8;
}

.item {
    margin: 10px 15px 0;
    padding: 10px;
    border-radius: 10px;
    background: #fff;

    > .header {
        display: flex;
        align-items: center;

        .check {
            width: 18px;
            height: 18px;    
            margin-right: 5px;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .un-check {
            width: 16px;
            height: 16px; 
            margin-right: 5px;
            border-radius: 50%;
            border: 1px solid #999;
        }

        > p {
            font-size: 16px;
            color: #333;
        }

        .freight-wrap {
            color: #666;
            font-size: 12px;
        }
    }

    .goods {
        margin-top: 10px;
        display: flex;
        align-items: center;

        .check {
            width: 18px;
            height: 18px;    
            margin-right: 5px;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .un-check {
            width: 16px;
            height: 16px; 
            margin-right: 5px;
            border-radius: 50%;
            border: 1px solid #999;
        }

        > .body {
            flex: 1;
            margin-left: 10px;
            display: flex;
            align-items: center;
            border-radius: 3px;

            > img {
                width: 90px;
                height: 90px;
                margin-right: 10px;
                object-fit: cover;
            }

            > div {
                flex: 1;
                height: 90px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .title {
                    font-size: 16px;
                    color: #333;
                }

                .unit {
                    font-size: 12px;
                    color: #666666;
                }

                > div {
                    display: flex;
                    align-items: center;

                    > p {
                        flex: 1;
                        font-size: 14px;
                        color: #EF1400;
                    }

                    > div {
                        display: flex;
                        align-items: center;

                        img {
                            width: 10px;
                            height: 10px;
                        }

                        input {
                            height: 25px;
                            width: 45px;
                            margin: 0 10px;
                            background: #F6F6F6;
                            font-size: 14px;
                            color: #000;
                            line-height: 25px;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }

    .delete {
        height: 90px;
        margin-left: 10px;
    }
}

.footer {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    background: #fff;

    .check {
        padding: 15px;
        display: flex;
        align-items: center;

        img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
        }

        div {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            margin-right: 10px;
            border: 1px solid #999;
        }

        p {
            font-size: 12px;
            color: #333;
        }
    }

    p {
        flex: 1;
        color: #333;
        font-size: 12px;

        .value {
            font-size: 14px;
            color: #EF1400;
        }
    }

    .btn {
        width: 180px;
        height: 50px;
        background: linear-gradient(226deg,#9cb2f4, #6472e8 100%);
        line-height: 50px;
        text-align: center;
        font-size: 18px;
        color: #fff;
    }
}
</style>